<template>
 <div class="wrapper">
    
      <div class="section section-signup page-header header-filter" :style="headerStyle">
        <div class="container">
          <div class="md-layout">
            <div
              class="md-layout-item md-size-33 md-medium-size-40 md-small-size-50 md-xsmall-size-70 mx-auto text-center"
            >
             <div>
            <md-button
              class=" md-danger md-round btnA"
              color="red"
              href="#/basic"
              >Retour</md-button
            ></div>
            <md-card>
              <md-card-header
                style="background: linear-gradient(80deg,#f95050,#1818fa);"
              >
                <h2 style="text-align:center">
                  Enregistrer un nouvel utilisateur
                </h2>
              </md-card-header>

              <md-card-content>
                <div
                  style="background-color:#e6fffa; padding:10px; border-radius:3px"
                >
                  <form role="form" @submit="registerUser">
                    <div class="form-group">
                      <label for="subject" style="color: black; font-weight: bold;">Sujet</label><br>
                      <input
                        type="text"
                        v-model="user.subject"
                        class="form-control inputSubject"
                        required
                        placeholder="Sujet"
                      />
                    </div>

                    <div class="form-group">
                      <label for="message" style="color: black; font-weight: bold;">Message</label><br>
                      <textarea
                        v-model="user.message"
                        required
                        placeholder="Ecrire ici les informations du bénévoles"
                       rows = "6"
                       class="texterea"
                      ></textarea>
                    </div>
                  <div>
                    <md-button type="submit" id="submit" class="md-danger md-round btn-sendM">
                      Envoyer
                    </md-button>
                    <span v-if="isclick===false">Message envoyé avec succès</span>
                    </div>
                  </form>
                </div>
              </md-card-content>
            </md-card>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "../http-common";
import router from "../router";
export default {
  components: {},
  bodyClass: "login-page",
  data() {
    return {
      isclick:true,
      user: {
        subject: "",
        email: "",
        message: "",
      },
      loader: false,
    };
  },
  props: {
    header: {
      type: String,
      default: require("@/assets/img/volunters.webp"),
    },
  },
  computed: {
    headerStyle() {
      return {
        backgroundImage: `url(${this.header})`,
      };
    },
  },
  methods: {
    registerUser(e) {
      e.preventDefault();
      //console.log(this.user);
      if (!window.confirm("Êtes-vous sûr de vouloir envoyer le formulaire ?")) {
      return; // Annuler l'action si l'utilisateur clique sur "Annuler"
    }
      this.loader = true;
      axios
        .post("/contact", this.user)
        .then(
          (response) =>
          console.log("response"),
          
          this.$router.push("/basic"),
        
        )
        .catch((error) =>
          //console.log(error.response),
          (this.loader = false));
      //console.log("mail en cours d'envoie");
    },
  },
};
</script>

<style lang="css">
.inputSubject{
  width: 80%;
  border-radius: 15px !important;
  height: 50px !important;
  margin-right: auto;
  margin-left: auto; 
 
}
.texterea{
  width: 80%;
  border-radius: 15px !important;
  height: auto !important;
   margin-right: auto;
  margin-left: auto; 
}

.btn-sendM{
  width: 80%;
  border-radius: 50px !important;
  height: 50px !important;
  margin-top: 20px;
   margin-right: auto;
  margin-left: auto; 
}
@media screen and (max-width: 1197px){
  .inputSubject{
  width: 80%;
  border-radius: 15px !important;
  height: 50px !important;

  margin-left: auto !important; 
  margin-right: auto !important;
 
}
.texterea{
  width: 80%;
  border-radius: 15px !important;
  height: auto !important;
  margin-left: auto !important; 
  margin-right: auto;
 

}

.btn-sendM{
  width: 80%;
  border-radius: 50px !important;
  height: 50px !important;
  margin-top: 20px;
  margin-left: auto !important;
  margin-right:auto !important;
}
}
@media screen and (max-width: 500px){
h2{
font-size: 25px !important;
}
}
</style>
